/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Autofill_Review_HintInputs */

const en_directory_submit_autofill_review_hint = /** @type {(inputs: Directory_Submit_Autofill_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Autofill to fill the form from your website. Review the details before submitting.`)
};

const zh_directory_submit_autofill_review_hint = /** @type {(inputs: Directory_Submit_Autofill_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autofill 会从你的网站填写表单，请在提交前检查内容。`)
};

/**
* | output |
* | --- |
* | "Use Autofill to fill the form from your website. Review the details before submitting." |
*
* @param {Directory_Submit_Autofill_Review_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_review_hint = /** @type {((inputs?: Directory_Submit_Autofill_Review_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_Review_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_review_hint(inputs)
	return zh_directory_submit_autofill_review_hint(inputs)
});
export { directory_submit_autofill_review_hint as "directory.submit.autofill_review_hint" }